import React, { Component } from 'react'
import PropTypes            from 'prop-types'
import './index.less'

class MajorItem extends Component {

  static propTypes = {
    history: PropTypes.object,
    major: PropTypes.object,
    onClick: PropTypes.func,
  }

  handleClick(major) {
    const { id } = major
    const { history, onClick } = this.props
    history.push(`/major/detail/${id}`)
    typeof onClick === 'function' && onClick(id)
  }

  render() {
    const { major } = this.props
    return (
      <div className="major-item" onClick={this.handleClick.bind(this, major)}>
        <span>{major.name}</span>
        <svg className="icon icon-indicator_3">
          <use xlinkHref="#icon-indicator_3"></use>
        </svg>
      </div>
    )
  }
}

MajorItem.defaultProps = {
  history: {
    push: () => {
    }
  },
  major: {},
}

export default MajorItem


// WEBPACK FOOTER //
// ./src/components/MajorItem/index.js